import React from "react";
import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { AuthProvider } from "@/contexts/AuthContext";
import { SiteSettingsProvider } from "@/contexts/SiteSettingsContext";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import WhatsAppButton from "@/components/layout/WhatsAppButton";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import RatesPage from "@/pages/RatesPage";
import ContactPage from "@/pages/ContactPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import PortalPage from "@/pages/PortalPage";
import DigitalAssetsPage from "@/pages/DigitalAssetsPage";
import BlogPage from "@/pages/BlogPage";
import BlogArticlePage from "@/pages/BlogArticlePage";
import { OrganizationSchema, ServiceSchema } from "@/components/SEOSchema";
import ReferralPage from "@/pages/ReferralPage";
import AdminPage from "@/pages/AdminPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import NotFoundPage from "@/pages/NotFoundPage";
import CookieConsent from "@/components/CookieConsent";
import AnalyticsInjector from "@/components/AnalyticsInjector";
import MetaInjector from "@/components/MetaInjector";
import MaintenanceGate from "@/components/MaintenanceGate";

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <AuthProvider>
          <SiteSettingsProvider>
            <MaintenanceGate>
              <div className="min-h-screen flex flex-col">
                <OrganizationSchema />
                <ServiceSchema />
                <AnalyticsInjector />
                <MetaInjector />
                <Navbar />
                <main className="flex-1">
                  <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/about" element={<AboutPage />} />
                    <Route path="/services" element={<ServicesPage />} />
                    <Route path="/rates" element={<RatesPage />} />
                    <Route path="/contact" element={<ContactPage />} />
                    <Route path="/digital-assets" element={<DigitalAssetsPage />} />
                    <Route path="/blog" element={<BlogPage />} />
                    <Route path="/blog/:slug" element={<BlogArticlePage />} />
                    <Route path="/referral" element={<ReferralPage />} />
                    <Route path="/admin" element={<AdminPage />} />
                    <Route path="/privacy" element={<PrivacyPage />} />
                    <Route path="/terms" element={<TermsPage />} />
                    <Route path="*" element={<NotFoundPage />} />
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/register" element={<RegisterPage />} />
                    <Route path="/portal" element={<PortalPage />} />
                  </Routes>
                </main>
                <Footer />
                <WhatsAppButton />
                <CookieConsent />
              </div>
            </MaintenanceGate>
          </SiteSettingsProvider>
        </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
